import { useEffect, useState } from 'react';

const copyToClipboard = async (value) => {
  if (!value) {
    return false;
  }

  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch {
    return false;
  }
};

export const useCopyToClipboard = ({ revertCopyStateTimeout = 3000 } = {}) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyText = (text) => {
    copyToClipboard(text).then(setIsCopied);
  };

  useEffect(() => {
    if (isCopied) {
      const timerId = setTimeout(
        () => setIsCopied(false),
        revertCopyStateTimeout
      );

      return () => clearTimeout(timerId);
    }
    return undefined;
  }, [isCopied]);

  return [isCopied, copyText];
};
